<template>
    <transition name="modal_fade" >
        <div  @keydown.esc="$emit('close')" >
            <div :class="classes" class="modal" role="dialog"  v-draggable @dragstart="setModal">
                <div class="modal_header">
                    {{heading}}
                    <button type="button" class="modal_btn_close" @click="$emit('close')" aria-label="Close modal"><span class="glyphicon glyphicon-remove"></span></button>
                </div>
                <div class="modal_body">
                    <slot name="body"></slot>
                </div>
                <div class="modal_footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import draggable from '@/directives/draggable';
    import {fileUploadStore} from '@/store/FileUpload.store';

    export default {
        name: "Modal",
        props: ['heading', 'classes'],
        directives: {
            draggable
        },
        methods: {
          setModal: function () {
             fileUploadStore.state.isModal = true;
          }
        }
    }
</script>

<style scoped>
.modal{
    position: fixed;
    margin-top: 15%;
    max-height: 700px; /* adjust the value as needed */
    overflow-y: auto;
}
.dropdownModal{
   height: 80%;
}
.wide80 {
    width: 80% !important;
}
.tall80 {
    max-height: 80% !important;
}
</style>